/** Methods offered when recording money. `in_kind` stays on older gifts only. */
export const CONTRIBUTION_METHODS = [
  'cash',
  'mobile_money',
  'card',
  'bank_transfer',
  'cheque',
  'hubtel',
] as const;

export type ContributionMethod = (typeof CONTRIBUTION_METHODS)[number];

/** Account type a non-cash method is paid into. Cash has no account. */
export const accountKindForMethod = (
  method: string,
): 'mobile_money' | 'bank_account' | 'hubtel_account' | null => {
  if (method === 'mobile_money') return 'mobile_money';
  if (method === 'card' || method === 'bank_transfer' || method === 'cheque') return 'bank_account';
  if (method === 'hubtel') return 'hubtel_account';
  return null;
};
